import { render, staticRenderFns } from "./ScheduleStyleTowIconLegend.vue?vue&type=template&id=288afc90&scoped=true"
var script = {}
import style0 from "./ScheduleStyleTowIconLegend.vue?vue&type=style&index=0&id=288afc90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "288afc90",
  null
  
)

export default component.exports